(function () {
  'use strict';

  var ENDPOINT = 'https://crm.bobateacompany.co.uk/api/v1/public/social-proof/recent-orders';
  var TOKEN = "n/KDQFsQkO0oI8YczEYZkzAP+SECtw/M4i8Rd8wbpqk=";
  var FIRST_SHOW_DELAY_MS = 4000;
  var POPUP_INTERVAL_MS = 25000;
  var POPUP_DURATION_MS = 5000;
  var DISMISSED_KEY = 'bobaSocialProofDismissed';
  var popupEl = null;
  var hideTimer = null;
  var intervalTimer = null;
  var items = [];
  var currentIndex = 0;

  function getSessionStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  var storage = getSessionStorage();
  if (storage && storage.getItem(DISMISSED_KEY) === '1') return;

  function injectStyles() {
    if (document.getElementById('boba-social-proof-popup-styles')) return;
    var style = document.createElement('style');
    style.id = 'boba-social-proof-popup-styles';
    style.textContent = '.boba-social-proof-popup{position:fixed;left:24px;bottom:150px;max-width:min(340px,calc(100vw - 48px));background:#fffaf4;border:1px solid #eadfce;border-radius:10px;box-shadow:0 12px 32px rgba(42,30,18,.18);color:#271b12;font-family:inherit;font-size:14px;line-height:1.35;z-index:9997;opacity:0;transform:translateY(18px);pointer-events:none;transition:opacity .28s ease,transform .28s ease}.boba-social-proof-popup.is-visible{opacity:1;transform:translateY(0);pointer-events:auto}.boba-social-proof-popup__inner{display:flex;align-items:flex-start;gap:12px;padding:13px 42px 13px 14px}.boba-social-proof-popup__icon{flex:0 0 auto;width:30px;height:30px;border-radius:999px;background:#2f2419;color:#fff;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:700}.boba-social-proof-popup__text{font-weight:600;letter-spacing:0;overflow-wrap:anywhere}.boba-social-proof-popup__close{position:absolute;top:7px;right:9px;width:28px;height:28px;border:0;background:transparent;color:#7b6a59;cursor:pointer;font-size:22px;line-height:1;padding:0}.boba-social-proof-popup__close:hover{color:#2f2419}@media (max-width:640px){.boba-social-proof-popup{left:18px;right:18px;bottom:150px;max-width:none}.boba-social-proof-popup__inner{padding-right:40px}}';
    document.head.appendChild(style);
  }

  function buildPopup() {
    injectStyles();
    var el = document.createElement('aside');
    el.id = 'boba-social-proof-popup';
    el.className = 'boba-social-proof-popup';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');

    var inner = document.createElement('div');
    inner.className = 'boba-social-proof-popup__inner';

    var icon = document.createElement('div');
    icon.className = 'boba-social-proof-popup__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';

    var text = document.createElement('div');
    text.className = 'boba-social-proof-popup__text';

    var close = document.createElement('button');
    close.className = 'boba-social-proof-popup__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close recent purchase popup');
    close.textContent = '×';
    close.addEventListener('click', function () {
      if (storage) storage.setItem(DISMISSED_KEY, '1');
      window.clearTimeout(hideTimer);
      window.clearInterval(intervalTimer);
      hidePopup();
    });

    inner.appendChild(icon);
    inner.appendChild(text);
    el.appendChild(inner);
    el.appendChild(close);
    document.body.appendChild(el);
    return el;
  }

  function normaliseItem(item) {
    if (!item || typeof item.product !== 'string') return null;
    var product = item.product.replace(/\s+/g, ' ').trim();
    if (!product) return null;
    var minutesAgo = Number(item.minutesAgo);
    if (!Number.isFinite(minutesAgo) || minutesAgo < 0) minutesAgo = 0;
    return {
      product: product,
      minutesAgo: Math.floor(minutesAgo)
    };
  }

  async function fetchItems() {
    try {
      var response = await fetch(ENDPOINT + '?limit=20', {
        method: 'GET',
        headers: { 'X-Social-Proof-Token': TOKEN },
        credentials: 'omit',
        cache: 'no-store'
      });
      if (!response.ok) return [];
      var data = await response.json();
      if (!data || !Array.isArray(data.items)) return [];
      return data.items.map(normaliseItem).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function messageFor(item) {
    return 'Someone just bought ' + item.product + ' · ' + item.minutesAgo + ' mins ago';
  }

  function hidePopup() {
    if (popupEl) popupEl.classList.remove('is-visible');
  }

  function showItem(item) {
    if (!item) return;
    if (!popupEl) popupEl = buildPopup();
    var textEl = popupEl.querySelector('.boba-social-proof-popup__text');
    textEl.textContent = messageFor(item);
    window.clearTimeout(hideTimer);
    window.requestAnimationFrame(function () {
      popupEl.classList.add('is-visible');
    });
    hideTimer = window.setTimeout(hidePopup, POPUP_DURATION_MS);
  }

  function showNext() {
    if (!items.length) return;
    showItem(items[currentIndex]);
    currentIndex = (currentIndex + 1) % items.length;
  }

  async function init() {
    items = await fetchItems();
    if (!items.length) return;
    window.setTimeout(showNext, FIRST_SHOW_DELAY_MS);
    intervalTimer = window.setInterval(showNext, POPUP_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
